import React from "react";
import ContactCard from "./contactcard"; // Adjust this import string path depending on file setup
import adith from "../../../assets/adith.png"; // Adjust this import string path depending on file setup
import gautam from "../../../assets/gautam.png"; // Adjust this import string path depending on file setup
import Marquee from "../marquee/marquee";
import Reveal from "../../common/Reveal";

const Widget = () => {
  // Array holding your contact data parameters cleanly
  const contactsData = [
    { 
      role: "Public Relation Head", 
      name: "Adith Reddy",
      cell: "7893813014",
      email: "r.sreepuram@iitg.ac.in",
      imageSrc: adith, // <-- Swap your imported/saved graphic pathway here later
      socialLinks: [
        {
          platform: "Instagram",
          url: "https://www.instagram.com/aadi_1204/",
        },
        {
          platform: "LinkedIn",
          url: "https://www.linkedin.com/in/adith-sreepuram/",
        },
      ],
    },
    {
      role: "Public Relation Head",
      name: "Gautam",
      cell: "9253643506",
      email: "gautam2024@iitg.ac.in",
      imageSrc: gautam, // <-- Swap your imported/saved graphic pathway here later
      socialLinks: [
        {
          platform: "Instagram",
          url: "https://www.instagram.com/gautamkaloria/",
        },
        {
          platform: "LinkedIn",
          url: "https://www.linkedin.com/in/gautam-kaloria-221277348",
        },
      ],
    },
  ];

  return (
    <div className="w-full py-16 px-6 bg-transparent flex flex-col items-center mt-0" id="footer">
      
      {/* Marquee */}
      <div className="mb-10">
        <Marquee text="Contact Us!" speed={12}/>
      </div>

      {/* Horizontal Alignment Layout Grid Wrapper */}
      <div className="flex flex-col lg:flex-row justify-center items-center gap-8 w-full max-w-[1340px]">
        {contactsData.map((contact, index) => (
          <Reveal
            key={index}
            delay={index * 140}
            className="w-full max-w-[638px]"
          >
            <ContactCard
              role={contact.role}
              name={contact.name}
              email={contact.email}
              cell={contact.cell}
              imageSrc={contact.imageSrc}
              socialLinks={contact.socialLinks}
            />
          </Reveal>
        ))}
      </div>

    </div>
  );
};

export default Widget;